import { DoqType } from '@ardoq/doq';
import { NoNumericFieldsDoq } from 'tabview/graphViews/emptyStates/NoNumericFieldsDoq';
import { NoDataAvailableDoq } from 'tabview/graphViews/emptyStates/NoDataAvailableDoq';
import { NoNumericValuesInFieldsDoq } from 'tabview/graphViews/emptyStates/NoNumericValuesInFieldsDoq';
import { NoDataWithFiltersDoq } from 'tabview/graphViews/emptyStates/NoDataWithFiltersDoq';
import { OnlyZeroValuesInBubbleSizeFieldDoq } from 'tabview/graphViews/emptyStates/OnlyZeroValuesInBubbleSizeFieldDoq';
import { BubbleChartEmptyStateData } from '@ardoq/bubble-chart';

export const DoqEmptyState = ({
  isWorkspaceEmpty,
  hasActiveFilter,
  allDescendantsIncluded,
  noNumericFields,
  isPresentationMode,
  onChangeFieldsClick,
  hasOnlyPointsWithZeroRadius,
  onChangeBubbleSizeField,
  onShowSizeZeroBubbles,
}: BubbleChartEmptyStateData) => {
  if (isWorkspaceEmpty) {
    return (
      <NoDataAvailableDoq
        doqType={DoqType.BUBBLE_CHART_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  if (hasActiveFilter || !allDescendantsIncluded) {
    return (
      <NoDataWithFiltersDoq
        doqType={DoqType.BUBBLE_CHART_ERROR}
        includeActions={false}
        canApplyIncludeAllDescendantsFilter
      />
    );
  }

  if (hasOnlyPointsWithZeroRadius) {
    return (
      <OnlyZeroValuesInBubbleSizeFieldDoq
        doqType={DoqType.BUBBLE_CHART_ERROR}
        onChangeBubbleSizeField={onChangeBubbleSizeField || (() => {})}
        onShowSizeZeroBubbles={onShowSizeZeroBubbles || (() => {})}
      />
    );
  }

  if (noNumericFields) {
    return <NoNumericFieldsDoq doqType={DoqType.BUBBLE_CHART_ERROR} />;
  }

  if (onChangeFieldsClick) {
    return (
      <NoNumericValuesInFieldsDoq
        doqType={DoqType.BUBBLE_CHART_ERROR}
        onChangeFieldsClick={onChangeFieldsClick}
      />
    );
  }

  return null;
};
